<div class="card">

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/percentuale-redenzione-indicator/percentuale-redenzione-indicator.component.html